module.exports = __webpack_public_path__ + "static/media/Ayaka.b7087367.png";